/* eslint-disable @nx/enforce-module-boundaries */
/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable sonarjs/no-collapsible-if */
import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
  ElementRef,
  OnDestroy,
} from '@angular/core';
import * as uuid from 'uuid';
import { Router } from '@angular/router';
import {
  getAdobeSiteSection,
  GroupItem,
  Menu,
} from '@cigna/cigna-for-brokers/shared/util';
import {
  AppstateFacade,
  Clients,
  DELEGATION_LEVEL,
  NavigationResponse,
  USER_TYPE,
} from '@cigna/cigna-for-brokers/shell/data-access';
import { CookieService } from 'ngx-cookie-service';
import { MatDialog } from '@angular/material/dialog';
import { HeaderProfileService } from '../+state/header-profiel.service';
import { ShellTrackHandlers } from '@cigna/cigna-for-brokers/shared/analytics-util';
import { MatMenuTrigger } from '@angular/material/menu';
import { FeatureTogglesFacade } from '@cigna/shared/angular/features-feature';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import includes from 'lodash/includes';
import { ContactUsComponent } from '@cigna/cigna-for-brokers/shared/ui';

@Component({
  selector: 'cigna-caheader-secure',
  templateUrl: './header-secure.component.html',
  styleUrls: ['./header-secure.component.scss'],
})
export class HeaderSecureComponent implements OnInit, OnChanges, OnDestroy {
  @Output() toggleSideMenu = new EventEmitter();

  @Input() firstName: string;
  @Input() lastName: string;
  @Input() internalFirstName: string;
  @Input() internalLastName: string;
  @Input() isInternalUser: string;
  @Input() isFromBRPortal: boolean;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  @Input() loading: boolean;
  @Input() groupItems: GroupItem[];
  @Input() searchedGroupItems: GroupItem[];
  @Input() searchByList: Array<{ id: string; name: string }>;
  @Input() selectedClient: string | undefined;
  @Input() defaultClientid: string;
  @Input() source: string | undefined;
  @Input() isImpersonatorFlag: boolean | undefined;
  @Input() selectedClientDetail: Clients | undefined;
  @Input() navigation: NavigationResponse | undefined;
  @Output() logout = new EventEmitter<void>();
  @Output() secureMessage = new EventEmitter<{ url: string; target: string }>();
  @Output() toggleSidenav = new EventEmitter<void>();
  @Output() toggleTheme = new EventEmitter<void>();
  @Output() toggleDir = new EventEmitter<void>();
  @Output() clientChange = new EventEmitter<GroupItem>();
  @Output() internalClientChange = new EventEmitter<GroupItem>();
  @Output() searchClient = new EventEmitter<{
    searchType: string;
    searchValue: string;
  }>();
  // eslint-disable-next-line @typescript-eslint/naming-convention
  sideBarToggleFlag: boolean;
  isDisplayClientLabel = true;
  isFirstTimeAlertStatus = true;
  // new list from left nav
  @Input() menuItemsWithSubMenu?: Menu[];
  // eslint-disable-next-line @typescript-eslint/naming-convention
  @Input() resizeSideNavToggle: boolean;
  isLinkEnabled: boolean;
  @Input() isScreenSmall: boolean;
  @Input() navigationEntitlements: string[] | undefined;
  @Output() openExternalPage = new EventEmitter<{ source: string }>();
  @Input() isBillpayEnabled: boolean;
  @Input() isBillpayFacetsEnabled: boolean;
  @Input() isGovNonFacetsEnabled: boolean;
  @Input() isGovFacetsEnabled: boolean;
  @Input() isIncentiveEnabled: boolean;
  @Input() isCoverageTransparencyEnabled: boolean;
  @Input() isEnableBankingNonFacets: boolean;
  @Input() isEnableEligibilityNonFacets: boolean;
  @Input() isEnableClaimsNonFacets: boolean;
  @Input() isEnableFundDrivenNonFacets: boolean;
  @Input() isEnableIcmsClient: boolean;
  @Input() isArchvdRptEnalbed: boolean;
  @Input() isSideBarToggleFlag: boolean;
  @Input() isMurEnabled: boolean;
  @Input() currentUrlPath: string;
  isCloseIconClicked = false;
  hasSecurityProfile: boolean | undefined;
  hasContactInfo: boolean | undefined;
  hasLogout: boolean | undefined;
  isIfpAEnabled: boolean;
  isSecurityProfileEnabled: boolean;
  private _ngUnsubscribe$: Subject<void> = new Subject<void>();
  dWidth = '60rem';

  isIfpAdminEnabled$ = this.featureTogglesFacade.featuresEnabled([
    'isIfpAdminEnabled',
  ]);
  isSecurityProfileEnabled$ = this.featureTogglesFacade.featuresEnabled([
    'isSecurityProfileEnabled',
  ]);
  did0830ChangesEnabled$ = this.featureTogglesFacade.featuresEnabled([
    'did0830ChangesEnabled',
  ]);

  @ViewChild(MatMenuTrigger) matMenuTrigger: MatMenuTrigger;

  constructor(
    private router: Router,
    private cookieService: CookieService,
    private appstateFacade: AppstateFacade,
    public dialog: MatDialog,
    public _service: HeaderProfileService,
    private analytics: ShellTrackHandlers,
    private featureTogglesFacade: FeatureTogglesFacade,
  ) {
    this.firstName = 'Venki';
    this.lastName = 'Govindaiah';

    this.start();
  }
  ngOnChanges(_changes: SimpleChanges): void {
    if (this.isFirstTimeAlertStatus) {
      this.isFirstTimeAlertStatus = false;
    }
  }

  getUserType(userTypeCd: string) {
    const userType = USER_TYPE.find((type) => type.code === userTypeCd);
    if (userType) {
      return userType.description;
    }
    return '';
  }
  getDelegationLevel(delegationLevelCode: number) {
    const delegationLevel = DELEGATION_LEVEL.find(
      (item) => item.code === delegationLevelCode,
    );
    if (delegationLevel) {
      return delegationLevel.description;
    }
    return '';
  }

  ngOnInit(): void {
    this.isIfpAdminEnabled$
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((isIfpAEnable) => {
        this.isIfpAEnabled = isIfpAEnable;
      });
    this.isSecurityProfileEnabled$
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((isSPEnabled) => {
        this.isSecurityProfileEnabled = isSPEnabled;
      });

    if (this.isIfpAEnabled) {
      this.hasSecurityProfile =
        this.navigationEntitlements?.includes('security-profile');
      this.hasContactInfo =
        this.navigationEntitlements?.includes('contact-info');
      this.hasLogout = this.navigationEntitlements?.includes('logout');
    } else {
      this.hasSecurityProfile = true;
      this.hasContactInfo = true;
      this.hasLogout = true;
    }
  }

  isFundingSolution(currentUrlPath: string) {
    return currentUrlPath === '/secure/commercial/funding';
  }

  isContactUsIntuitive(currentUrlPath: string) {
    return includes(currentUrlPath, '/secure/contact-us');
  }

  toggleSideMenuFn() {
    this.sideBarToggleFlag = !this.sideBarToggleFlag;
    this.toggleSideMenu.emit(this.sideBarToggleFlag);
  }
  navigateSecureMessage(): void {
    const url = `${
      window.location.origin
    }/router/secure_email/secure/client?service_reference_id=${uuid.v4()}`;
    this.secureMessage.next({ url, target: '_blank' });
  }
  processLogout(): void {
    if (!this.isImpersonatorFlag) {
      this.analytics.trackEventOther({}, 'Logout', 'ac24438', {
        eVar119: 'MTD-1460',
        eVar120: 'profile-header',
        prop67: 'action',
        channel: getAdobeSiteSection(this.router.url).channel,
        pageName: getAdobeSiteSection(this.router.url).pageName,
        prop20: 'top-profile-menu',
      });
      this.logout.next();
    }
  }
  navigateSecureMessageLayout(data: { url: string; target: string }) {
    this.appstateFacade.windowOpen(data);
  }
  appRedirect(data: { redirect: string }) {
    this.appstateFacade.appRedirect(data);
  }
  profileContactUS() {
    if (!this.isImpersonatorFlag) {
      this.analytics.trackEventOther({}, 'Contact Us', 'ac24438', {
        eVar119: 'MTD-1460',
        eVar120: 'profile-header',
        prop67: 'action',
        channel: getAdobeSiteSection(this.router.url).channel,
        pageName: getAdobeSiteSection(this.router.url).pageName,
        prop20: 'top-profile-menu',
      });
    }

    this.did0830ChangesEnabled$
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((did0830ChangesEnabled) => {
        if (did0830ChangesEnabled) {
          this.router.navigate(['/secure/home/contact-us']);
        } else {
          if (this.isImpersonatorFlag) {
            this.dWidth = '40rem';
          }

          this.dialog.open(ContactUsComponent, {
            width: this.dWidth,
            autoFocus: false,
            disableClose: true,
          });
        }
      });
  }
  securityProfile(): void {
    if (this.isSecurityProfileEnabled && !this.isImpersonatorFlag) {
      this.analytics.trackEventOther({}, 'Security Profile', 'ac24438', {
        eVar119: 'MTD-1460',
        eVar120: 'profile-header',
        prop67: 'action',
        channel: getAdobeSiteSection(this.router.url).channel,
        pageName: getAdobeSiteSection(this.router.url).pageName,
        prop20: 'top-profile-menu',
      });
      this.router.navigateByUrl('/secure/security-profile');
    } else {
      this.analytics.trackEventOther({}, 'Security Profile', 'ac24438', {
        eVar119: 'MTD-1460',
        eVar120: 'profile-header',
        prop67: 'action',
        channel: getAdobeSiteSection(this.router.url).channel,
        pageName: getAdobeSiteSection(this.router.url).pageName,
        prop20: 'top-profile-menu',
      });
      this._service.getBrokerSecurityProfileUrl();
    }
  }
  closeMenu() {
    this.matMenuTrigger.closeMenu();
  }
  closeIcon() {
    this.isCloseIconClicked = true;
    // this.menuTrigger.closeMenu();
  }

  ngOnDestroy() {
    this.stop();
  }

  start(): void {
    window.addEventListener('storage', this.storageEventListener.bind(this));
  }

  stop(): void {
    window.removeEventListener('storage', this.storageEventListener.bind(this));
  }

  storageEventListener(event: StorageEvent) {
    if (event.storageArea === localStorage) {
      if (event?.key && event.key === 'logout-event') {
        this.processLogout();
      }
    }
  }
}
